import { useState } from "react";
import { createWorkspaceExport } from "../workspace-storage";

function download(name:string,value:unknown) {
  const blob=new Blob([JSON.stringify(value,null,2)],{type:"application/json"});
  const link=document.createElement("a");
  link.href=URL.createObjectURL(blob);
  link.download=name;
  link.click();
  setTimeout(()=>URL.revokeObjectURL(link.href),0);
}

export function ForensicWorkspaceExportPage() {
  const [status,setStatus]=useState("Ready to export. No migration or normalisation will run.");
  async function run() {
    setStatus("Preparing exact raw export…");
    try{
      const value=await createWorkspaceExport(localStorage,location.origin),stamp=value.manifest.createdAt.replace(/[:.]/g,"-");
      download(`workspace-recovery-manifest-${stamp}.json`,value.manifest);
      download(`workspace-recovery-raw-sources-${stamp}.json`,value.sources);
      setStatus(`Exported ${value.sources.length} workspace value${value.sources.length===1?"":"s"}. The primary key was not changed.`);
    }catch(reason){setStatus(reason instanceof Error?reason.message:"The workspace export failed.")}
  }
  return <main className="workspace-recovery-page"><section className="workspace-recovery-card">
    <p className="eyebrow">Read-only forensic export</p>
    <h1>Export original workspace</h1>
    <p>This page does not start the portal, migrate records or enable autosave.</p>
    <button className="primary-button" onClick={()=>void run()}>Export original workspace</button>
    <p role="status">{status}</p>
  </section></main>;
}
